const STORAGE_KEY = 'ui.tours.disabled';

export function isTourDisabled(): boolean {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(STORAGE_KEY) === 'true';
}

export function setTourDisabled(disabled: boolean) {
  if (typeof window === 'undefined') return;
  if (disabled) {
    window.localStorage.setItem(STORAGE_KEY, 'true');
  } else {
    window.localStorage.removeItem(STORAGE_KEY);
  }
}

